import React from 'react';
import { createUseStyles, Text } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles';
const useStyles = createUseStyles(styles, 'CopilotSidebarHistory');

const CopilotSidebarHistoryTab = () => {
    const { t } = useWeb5Context();
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Text type="h4">{t('label_copilot_tab_history')}</Text>
        </div>
    );
};

export default CopilotSidebarHistoryTab;
